import API from "../API";
import axios, { AxiosRequestConfig } from "axios";

declare const LogAndNotification: string;
export default class NotificationAPI extends API {
  constructor() {
    super("notification", LogAndNotification);
  }

  async getUserNotifications(
    userId: string,
    roleId: string,
    teamIds: string[]
  ) {
    axios.defaults.baseURL = LogAndNotification;

    return axios.get(`get/user/notification/${userId}`, {
      params: {
        role_id: roleId ?? "",
        team_ids: teamIds[0] != null ? teamIds : ["6851456507901b817d0a4392"], // Axios will serialize array properly
      },
    });
  }

  async markAsRead(id: string, userId: string) {
    axios.defaults.baseURL = LogAndNotification;

    return axios.post(`mark-notification-read/${id}`, { user_id: userId });
  }

  async markAllAsRead(userId: string) {
    axios.defaults.baseURL = LogAndNotification;
    return axios.post(`mark-all-notifications-read/${userId}`);
  }

  async sendNotification(data: any, token: string): Promise<any> {
    try {
      axios.defaults.baseURL = LogAndNotification;
      const response = await axios.post(`send/direct/notification`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error(error.response.data);
        return error.response.data;
      }
    }
  }
}
